import { frontendURL } from '../../../helper/URLHelper';

const TrackingDashboard = () => import('./TrackingDashboard.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tracking'),
    name: 'tracking_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: TrackingDashboard,
  },
];
